var $ = require('jquery');

$(function () {

    $('.column-content-preview-210__list--mobile').slick({
        arrows: true,
        centerMode: true,
        centerPadding: '30px',
        mobileFirst: true,
        responsive: [{
            breakpoint: 767,
            settings: 'unslick'
        }],
        rtl: window.GenericUtilities.isRTL()
    });
    // to get slick slider to initialize on screen resize
    // https://github.com/kenwheeler/slick/issues/1730
    $(window).on('resize orientationchange', function () {
        $('.column-content-preview-210__list--mobile').slick('resize');
    });

    $('.column-content-preview-210__show-more-less a').on('click', function (e) {
        e.preventDefault();
        $('.column-content-preview-210').toggleClass('show-more');
    });

    $('.column-content-preview-210__list__item__image').each(function () {
        if ($(this).find('img').length == 0) {
            $(this).addClass('no-image');
        }
    });
});
